/* ============================================================
   ns-rouge-lp.js: 大和ルージュLP(/pages/yamato-rouge)
   - バリアント(6本/8本)選択、数量、合計表示
   - /cart/add.js での投入とヘッダーカート数の更新
   - 下部追従ドック(スクロールCTA)
   - リビール(スクロール表示)
   お中元LP(ns-ochugen-lp.js)の下部ドック/カート更新の方式を踏襲。
   作成: 2026-08-25
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-nsrg-root]');
  if (!root) return;

  document.documentElement.classList.add('nsrg-js');

  /* ---------- 小道具 ---------- */
  function yen(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- リビール ---------- */
  (function reveal() {
    var items = $$('.nsrg-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- FV(2026-08-25 v2) ----------
     - SPのFV高さ計算用に、ヘッダーの実測高をCSS変数 --nsrg-header-h へ渡す
     - ロード演出(.is-live): テキストの段差フェード + 写真の浅いズーム(CSS側で定義)
     - PCのみ: スクロールで写真をわずかに沈める視差(coverの上下クロップ余白の範囲内) */
  (function fvIntro() {
    var fv = $('#fv');
    if (!fv) return;
    var img = $('.nsrg-fv__media img', fv);

    function setHeaderVar() {
      var h = document.querySelector('.shopify-section__header');
      if (h) fv.style.setProperty('--nsrg-header-h', Math.round(h.getBoundingClientRect().height) + 'px');
    }
    setHeaderVar();
    window.addEventListener('resize', setHeaderVar, { passive: true });

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { fv.classList.add('is-live'); });
    });

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pc = window.matchMedia('(min-width: 768px)');
    var waiting = false;
    function parallax() {
      waiting = false;
      if (!img) return;
      if (reduced.matches || !pc.matches) { img.style.transform = ''; return; }
      var y = Math.min(window.pageYOffset * 0.1, 72);
      img.style.transform = 'translate3d(0,' + y + 'px,0)';
    }
    window.addEventListener('scroll', function () {
      if (waiting) return;
      waiting = true;
      window.requestAnimationFrame(parallax);
    }, { passive: true });
  })();

  /* ---------- ページ内ジャンプ(追従ヘッダーぶんを差し引く) ---------- */
  function headerOffset() {
    var h = document.querySelector('.shopify-section__header');
    if (!h) return 0;
    var st = window.getComputedStyle(h);
    return (st.position === 'sticky' || st.position === 'fixed') ? h.getBoundingClientRect().height : 0;
  }
  function jumpTo(target) {
    var el = typeof target === 'string' ? $(target) : target;
    if (!el) return;
    var y = window.pageYOffset + el.getBoundingClientRect().top - headerOffset() - 12;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nsrg-jump]');
    if (!a) return;
    e.preventDefault();
    jumpTo(a.getAttribute('href') || '#buy');
  });

  /* ---------- 購入ボックス ---------- */
  var buy = $('#buy');
  var radios = $$('input[name="nsrg-variant"]');
  var qtyInput = $('[data-nsrg-qty-input]');
  var totalEl = $('[data-nsrg-total]');
  var addBtn = $('[data-nsrg-add]');
  var feedback = $('[data-nsrg-feedback]');
  var nextBox = $('[data-nsrg-next]');

  function currentRadio() {
    return radios.filter(function (r) { return r.checked; })[0] || null;
  }
  function normQty(v) {
    var n = parseInt(v, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 20) n = 20;
    return n;
  }
  function syncOptStyles() {
    radios.forEach(function (r) {
      var label = r.closest('.nsrg-buy__opt');
      if (label) label.classList.toggle('is-on', r.checked);
    });
  }
  function syncTotal() {
    var r = currentRadio();
    if (!r || !totalEl) return;
    var price = parseInt(r.getAttribute('data-price'), 10) || 0;
    var qty = normQty(qtyInput ? qtyInput.value : 1);
    totalEl.innerHTML = yen(price * qty) + '<small>送料込み</small>';
  }
  function resetFeedback() {
    if (!feedback) return;
    feedback.textContent = '';
    feedback.classList.remove('is-shown', 'is-error');
    if (nextBox) nextBox.classList.remove('is-shown');
  }
  function showFeedback(msg, isError) {
    if (!feedback) return;
    feedback.textContent = msg;
    feedback.classList.add('is-shown');
    feedback.classList.toggle('is-error', !!isError);
  }

  radios.forEach(function (r) {
    r.addEventListener('change', function () {
      syncOptStyles();
      syncTotal();
      resetFeedback();
      renderDock();
    });
  });

  $$('[data-nsrg-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var d = parseInt(btn.getAttribute('data-nsrg-qty'), 10) || 0;
      qtyInput.value = normQty(normQty(qtyInput.value) + d);
      syncTotal();
      renderDock();
    });
  });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      qtyInput.value = normQty(qtyInput.value);
      syncTotal();
      renderDock();
    });
  }

  /* ---------- カート投入 ---------- */
  var adding = false;
  function addToCart(fromDock) {
    if (adding) return;
    var r = currentRadio();
    if (!r) return;
    adding = true;
    var qty = normQty(qtyInput ? qtyInput.value : 1);
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'カートに追加しています'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(r.value, 10), quantity: qty })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (out) {
        if (!out.ok) {
          var msg = (out.data && out.data.description) || 'カートに追加できませんでした。時間をおいてお試しください。';
          showFeedback(msg, true);
          return;
        }
        showFeedback('カートに追加しました。', false);
        if (nextBox) nextBox.classList.add('is-shown');
        if (fromDock) jumpTo('#buy');
        refreshCart();
      })
      .catch(function () {
        showFeedback('通信に失敗しました。電波の良い場所でもう一度お試しください。', true);
      })
      .then(function () {
        adding = false;
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'カートに入れる'; }
      });
  }
  if (addBtn) addBtn.addEventListener('click', function () { addToCart(false); });

  /* ---------- 下部ドック(2026-08-25 v2: 数量ステッパー付き) ---------- */
  var dock = null, dockInfo = null, dockBtn = null, dockCount = null;
  var cartCount = 0;

  function buildDock() {
    if (dock || !radios.length) return;
    dock = document.createElement('div');
    dock.className = 'nsrg-dock';
    dock.innerHTML =
      '<div class="nsrg-dock__panel">' +
        '<div class="nsrg-dock__info" data-nsrg-dock-info></div>' +
        '<span class="nsrg-dock__stepper">' +
          '<button type="button" data-nsrg-dock-qty="-1" aria-label="数量を1減らす">-</button>' +
          '<b data-nsrg-dock-count aria-live="polite">1</b>' +
          '<button type="button" data-nsrg-dock-qty="1" aria-label="数量を1増やす">+</button>' +
        '</span>' +
        '<button type="button" class="nsrg-dock__btn" data-nsrg-dock-btn>カートに入れる</button>' +
      '</div>';
    document.body.appendChild(dock);
    dockInfo = $('[data-nsrg-dock-info]', dock);
    dockBtn = $('[data-nsrg-dock-btn]', dock);
    dockCount = $('[data-nsrg-dock-count]', dock);

    dockInfo.addEventListener('click', function () { jumpTo('#buy'); });
    /* ドックの数量は購入ボックスの数量入力と常に同期させる(正は qtyInput) */
    dock.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nsrg-dock-qty]');
      if (!b || !qtyInput) return;
      var d = parseInt(b.getAttribute('data-nsrg-dock-qty'), 10) || 0;
      qtyInput.value = normQty(normQty(qtyInput.value) + d);
      syncTotal();
      renderDock();
    });
    dockBtn.addEventListener('click', function () {
      if (cartCount > 0 && dockBtn.getAttribute('data-mode') === 'checkout') {
        window.location.href = '/cart';
        return;
      }
      addToCart(true);
    });
    renderDock();
  }

  function renderDock() {
    if (!dock || !dockInfo || !dockBtn) return;
    var r = currentRadio();
    if (!r) return;
    var price = parseInt(r.getAttribute('data-price'), 10) || 0;
    var label = r.getAttribute('data-label') || '';
    var qty = normQty(qtyInput ? qtyInput.value : 1);

    dock.classList.toggle('is-cart', cartCount > 0);
    if (dockCount) dockCount.textContent = qty;

    if (cartCount > 0) {
      dockInfo.innerHTML =
        '<span class="nsrg-dock__chip">カートに' + cartCount + '点</span>' +
        '<span>お会計へ進めます</span>';
      dockBtn.textContent = 'ご注文へ進む';
      dockBtn.setAttribute('data-mode', 'checkout');
      dockBtn.classList.add('nsrg-dock__btn--cart');
    } else {
      dockInfo.innerHTML =
        '<span class="nsrg-dock__chip">送料込み</span>' +
        '<span>' + label + (qty > 1 ? '×' + qty : '') + '<b>' + yen(price * qty) + '</b></span>' +
        '<span class="nsrg-dock__note">9月中旬から順次発送</span>';
      dockBtn.textContent = 'カートに入れる';
      dockBtn.setAttribute('data-mode', 'add');
      dockBtn.classList.remove('nsrg-dock__btn--cart');
    }
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartCount = c.item_count || 0;
        renderDock();
        // テーマ(Warehouse)のヘッダーカート数を更新
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { /* 失敗しても表示は保つ */ });
  }

  /* FVを過ぎ、かつ購入ボックスが画面内に無いときだけドックを出す */
  function updateDockVisibility() {
    if (!dock) return;
    var fv = $('#fv');
    var pastFv = fv ? (fv.getBoundingClientRect().bottom < 40) : true;
    var buyVisible = false;
    if (buy) {
      var rect = buy.getBoundingClientRect();
      buyVisible = rect.top < window.innerHeight - 80 && rect.bottom > 120;
    }
    var show = pastFv && !buyVisible;
    dock.classList.toggle('is-shown', show);
    document.body.classList.toggle('nsrg-dock-active', show);
  }

  if (radios.length) {
    syncOptStyles();
    syncTotal();
    buildDock();
    refreshCart();
    updateDockVisibility();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { updateDockVisibility(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', updateDockVisibility, { passive: true });
  }
})();
